export default "__VITE_ASSET__BY_iGMHw__"